import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import UserDetails from "./UserDetails";
import {ShoppingCart} from "./ShoppingCart";
import AppProps from "../../static/js/AppProps";
import {useAuth} from "../../context/AuthContext";
import Login from "../auth/Login";

const User = () => {
    const {loading: authLoading, logout} = useAuth();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (authLoading) return;

        const redirectToLogin = () => {
            logout();
            navigate(Login.link, {replace: true});
        };

        const fetchUser = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                setLoading(false);
                redirectToLogin();
                return;
            }
            try {
                const response = await fetch(
                    `${AppProps.spring_server_url}/user`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`,
                        }
                    }
                );
                if (!response.ok) {
                    redirectToLogin();
                    return;
                }
                const data = await response.json();
                if (!data?.username) {
                    redirectToLogin();
                    return;
                }
                setUser(data);
            } catch (err) {
                redirectToLogin();
            } finally {
                setLoading(false);
            }
        };
        fetchUser();
    }, [authLoading, logout, navigate]);

    if (authLoading || loading) {
        return (
            <div className="d-flex justify-content-center align-items-center"
                 style={{height: '200px', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                <div className="text-center">
                    <div className="spinner-border text-white" role="status" style={{width: '3rem', height: '3rem'}}>
                        <span className="visually-hidden">Загрузка...</span>
                    </div>
                    <p className="mbr-fonts-style mbr-white mt-3 display-7">
                        Загрузка данных пользователя...
                    </p>
                </div>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    return (
        <section data-bs-version="5.1" className="team2 cid-uLLMWbXtPL" id="team2-26">
            <div className="container py-4">
                <div className="row">
                    <div className="col-md-6">
                        <UserDetails user={user}/>
                    </div>
                    <div className="col-md-6">
                        <ShoppingCart/>
                    </div>
                </div>
            </div>
        </section>
    );
};

User.link = "/user";

export default User;
